/**
 * src/lib/useNoindex.js — marks the current page `noindex` for its lifetime.
 *
 * Extracted from DesignSpecimen.jsx (Phase 1), now shared with
 * DesignGallery.jsx (Phase 3) — both are working design artefacts, not
 * product pages, reachable only by direct URL. The SPA has one static
 * index.html and no per-route server-rendered `<head>`, so this is done at
 * runtime, scoped to exactly the page that mounts it.
 */
import { useEffect } from 'react';

export function useNoindex() {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);
}
